export default __webpack_public_path__ + "8980f68979cf8b750f161de5aa15b023.svg";